// React/finance-app/src/UserLogin.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";

export default function UserLogin() {
  const [userCode, setUserCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await api.post("/user-token", {
        user_code: userCode,
        password: password,
      });

      const { access_token, user_code: code } = response.data;

      // CRITICAL: Always force role to "user" for user login
      localStorage.setItem("token", access_token);
      localStorage.setItem("role", "user");  // ← Force "user" always
      localStorage.setItem("user_code", code || userCode);

      console.log("✅ User logged in:", {
        role: "user",
        user_code: code || userCode,
      });

      // Redirect to user dashboard
      navigate("/user");
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.message ||
        "Login failed. Please check your credentials.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <h3 className="text-center mb-4">User Login</h3>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="userCode" className="form-label">
                    User Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="userCode"
                    value={userCode}
                    onChange={(e) => setUserCode(e.target.value.toUpperCase())}
                    placeholder="e.g., KD1"
                    required
                    autoFocus
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Signing in...
                    </>
                  ) : (
                    "Sign In"
                  )}
                </button>
              </form>

              <div className="text-center mt-3">
                <small className="text-muted">
                  Staff? <a href="/login">Login here</a>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
